import { Component } from 'react';
import ReactModal from '../../../../../../components/Modal';
import { withTranslation } from 'react-i18next';
import PromptsView from '../../../../promptGenerator/components/PromptsView';
import AddKeywordModal from '../../addKeywordModal';

class PromptsModal extends Component {
    constructor(props) {
        super(props);

        this.showOpened = this.showOpened.bind(this);
        this.onClickOnStep = this.onClickOnStep.bind(this);
        this.onSelectPrompts = this.onSelectPrompts.bind(this);
        this.openAddKeywordModal = this.openAddKeywordModal.bind(this);
        this.closeAddKeywordModal = this.closeAddKeywordModal.bind(this);
        this.onSelectAllPrompts = this.onSelectAllPrompts.bind(this);

        this.state = {
            selectedItems: ['l-0'],
            selectedCollapse: null,
            isAddKeywordModalOpen: false,
            selectedPrompts: [],
        };
    }

    componentDidUpdate(prevProps) {
        // The pane keeps one instance while the user clicks from topic to topic, so a
        // selection made under the previous topic would otherwise still be sitting here,
        // invisible, and would go out with the next Track.
        if (prevProps.topic?.id !== this.props.topic?.id) {
            this.setState({ selectedPrompts: [] });
        }
    }

    /**
     * What Track actually submits.
     *
     * The prompts the project already has are ticked and locked in the list, so they should
     * never be sent a second time. Filtering here rather than trusting the checkboxes keeps
     * that true no matter how a prompt reached the selection -- including one picked before
     * it was tracked, which a refreshed project turns into an already-tracked prompt while it
     * is still selected.
     */
    get promptsToTrack() {
        const tracked = this.props.alreadyTrackedPrompts ?? [];
        return this.state.selectedPrompts.filter((prompt) => !tracked.includes(prompt));
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => {
            return item.unique_url_slug.toLowerCase().includes(search.toLowerCase());
        });
    }

    showOpened(name, value) {
        return this.state.selectedItems.includes(name) ? value ?? 'active' : '';
    }

    onClickOnStep(id) {
        this.setState({
            selectedItems: this.state.selectedItems.includes(id)
                ? this.state.selectedItems.filter((item) => item !== id)
                : [...this.state.selectedItems, id],
        });
    }

    onSelectPrompts(prompt) {
        this.setState({
            selectedPrompts: this.state.selectedPrompts.includes(prompt)
                ? this.state.selectedPrompts.filter((item) => item !== prompt)
                : [...this.state.selectedPrompts, prompt],
        });
    }

    openAddKeywordModal() {
        this.setState({ isAddKeywordModalOpen: true });
    }

    closeAddKeywordModal() {
        this.setState({ isAddKeywordModalOpen: false });
        // Whatever was just tracked is part of the project now, so the list has to be told --
        // otherwise those prompts stay unticked and selectable and go out again on the next
        // Track. Closing without tracking refetches the same thing, which costs a request and
        // changes nothing.
        this.props.onTracked?.();
    }

    onSelectAllPrompts(prompts) {
        const allSelected = prompts.every((prompt) => this.state.selectedPrompts.includes(prompt));
        this.setState({
            selectedPrompts: allSelected
                ? this.state.selectedPrompts.filter((item) => !prompts.includes(item))
                : [...new Set([...this.state.selectedPrompts, ...prompts])],
        });
    }

    render() {
        const { t } = this.props;
        return (
            <div>
                <div>
                    <div className="prompt-history-modal">
                        <>
                            <div className="my-20">
                                <div className={'prompt-generator-body-box grid-1 '}>
                                    <div className="prompt-generator-body-box-content">
                                        <PromptsView
                                            item={this.props.topic}
                                            showOpened={this.showOpened}
                                            onClickOnStep={() => {}}
                                            headerKey={'name'}
                                            selectedItems={this.state.selectedPrompts}
                                            onSelectPrompts={this.onSelectPrompts}
                                            uniqueKey={'l-0'}
                                            onSelectAllPrompts={this.onSelectAllPrompts}
                                            promptKey="generated_prompts"
                                            hideCollapse
                                            disabledPrompts={this.props.alreadyTrackedPrompts}
                                        />
                                    </div>
                                </div>
                            </div>
                        </>
                    </div>
                    <div className="btn-wrapper">
                        <button
                            className="button button-filled button-primary width-sm btn align-items-center justify-content-center"
                            onClick={this.openAddKeywordModal}
                            disabled={this.promptsToTrack.length === 0}
                        >
                            {t('ai_tracking.prompt_history.track_selected_prompts')}
                        </button>
                    </div>
                </div>
                {this.state.isAddKeywordModalOpen && (
                    <AddKeywordModal
                        isOpen={this.state.isAddKeywordModalOpen}
                        onClose={this.closeAddKeywordModal}
                        prompts={this.promptsToTrack}
                        projectId={this.props.projectId}
                    />
                )}
            </div>
        );
    }
}

export default withTranslation()(PromptsModal);
